export function formatAmount(amount) {
  if (amount === null || amount === undefined || amount === 0) return '';

  if (amount >= 10) return Math.round(amount).toString();

  const rounded = Math.round(amount * 8) / 8;
  const whole = Math.floor(rounded);
  const frac = Math.round((rounded - whole) * 8);
  const fracChars = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'];
  const fracStr = frac > 0 && frac < 8 ? fracChars[frac] : '';

  if (whole === 0) return fracStr || '';
  return `${whole}${fracStr}`;
}

export function convertIngredient(amount, unit, system) {
  if (amount === null || amount === undefined) {
    return { amount: null, unit: unit || 'count' };
  }

  if (system === 'metric') {
    if (unit === 'g' && amount >= 1000) return { amount: amount / 1000, unit: 'kg' };
    if (unit === 'ml' && amount >= 1000) return { amount: amount / 1000, unit: 'L' };
    return { amount, unit: unit || 'count' };
  }

  // Imperial conversions
  if (unit === 'g') {
    if (amount >= 454) return { amount: amount / 453.59, unit: 'lbs' };
    return { amount: amount / 28.35, unit: 'oz' };
  }
  if (unit === 'kg') return { amount: amount * 2.205, unit: 'lbs' };
  if (unit === 'ml') {
    if (amount >= 120) return { amount: amount / 240, unit: 'cups' };
    if (amount >= 15) return { amount: amount / 15, unit: 'tbsp' };
    return { amount: amount / 5, unit: 'tsp' };
  }
  if (unit === 'L') return { amount: amount * 4.227, unit: 'cups' };

  return { amount, unit: unit || 'count' };
}

export function convertTemp(text, system) {
  if (!text) return text;
  if (system === 'imperial') {
    return text.replace(/(\d+)°?C(?=[/,\s)]|$)/g, (_, c) => {
      return `${Math.round(parseInt(c) * 9 / 5 + 32)}°F`;
    });
  }
  // Metric: add ° symbol where missing
  return text.replace(/(\d+)C(?=[/,\s)]|$)/g, '$1°C');
}
